module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-grey-5-9e4af03b54b69e5c2027236a4c5c3fcd.png";